module.exports = __webpack_public_path__ + "img/tutorial07.937a7a2d.png";